<template>
  <div class="tool-modal-webhook">
    <snow-input
      v-model="form.description"
      label="Nome da configuração"
      :errors="errors.description"
    />
    <h5>
      Quando acontecerem os seguintes eventos:
    </h5>

    <div class="checkbox-group-container">
      <div class="d-flex flex-column">
        <h6 class="text-semibold mb-3">Compras:</h6>
        <snow-checkbox-group v-model="form.events" :options="orderEvents" />
      </div>
      <div class="d-flex flex-column">
        <h6 class="text-semibold mb-3">Assinaturas:</h6>
        <snow-checkbox-group v-model="form.events" :options="planEvents" />
      </div>
      <div class="d-flex flex-column">
        <h6 class="text-semibold mb-3">Outros:</h6>
        <snow-checkbox-group v-model="form.events" :options="otherEvents" />
      </div>
    </div>

    <snow-select
      v-model="form.product_id"
      label="No produto:"
      :disabled="!!form.id"
      :options="products.map(({ id, name }) => ({ id, name }))"
    />
    <snow-input
      v-model="form.url"
      label="Enviar para a url"
      :errors="errors.url"
    />

    <snow-input
      v-model="form.internal_id"
      mask="#############3"
      label="ID externo do produto (opcional)"
      :errors="errors.internal_id"
    />
    <snow-input
      v-model="form.token"
      label="Token da API (opcional)"
      :errors="errors.token"
    />

    <snow-switch v-model="form.extras.is_json" label="Enviar no formato JSON" />

    <div class="snow-submit-buttons">
      <snow-button
        size="lg"
        class="order-lg-1"
        text="Salvar"
        @click="submit"
        :loading="loading"
        :disabled="!isValid"
      />
      <snow-button
        size="lg"
        variant="gray"
        text="Cancelar"
        @click="$emit('close')"
        :disabled="loading"
      />
    </div>
  </div>
</template>
<script>
import { formFields } from "@/functions/helpers";
import { mapState } from "vuex";
export default {
  props: {
    integrationToEdit: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      ...formFields(
        [
          "id",
          "url",
          "status",
          "description",
          "events",
          "token",
          "extras",
          "type",
          "internal_id",
          "product_id"
        ],
        {
          events: [],
          extras: { is_json: false }
        }
      ),
      loading: false
    };
  },
  computed: {
    ...mapState("integration", ["typeEvents"]),
    ...mapState("product", ["products"]),
    isValid() {
      return (
        this.form.events.length &&
        this.form.description &&
        this.form.product_id &&
        this.form.url
      );
    },
    orderEvents() {
      let types = [
        "approved",
        "chargeback",
        "generated_billet",
        "purchase_denied",
        "reversal",
        "pix_generated"
      ];
      return this.typeEvents.filter(t => types.includes(t.id));
    },
    planEvents() {
      let types = ["unsubscribe"];
      return this.typeEvents.filter(t => types.includes(t.id));
    },
    otherEvents() {
      let types = ["jumped_in_flight"];
      return this.typeEvents.filter(t => types.includes(t.id));
    }
  },
  methods: {
    submit() {
      this.loading = true;

      const data = {
        ...this.form,
        internal_id: this.form.internal_id
          ? parseInt(this.form.internal_id)
          : null
      };
      data.events = data.events.map(e => {
        return { event: e };
      });
      let action = "integration/postIntegration";
      if (this.integrationToEdit) {
        data.id = this.integrationToEdit.id;
        action = "integration/putIntegration";
      }

      this.$store
        .dispatch(action, data)
        .then(() => {
          setTimeout(() => {
            this.$message.success("A configuração foi salva!");
            this.$emit("refresh");
            this.$emit("close");
          }, 5000); // :(
        })
        .catch(error => {
          this.$message.error("Erro ao salvar configuração");
          this.errors = error.response.data;
          this.loading = false;
        });
    }
  },
  mounted() {
    if (this.integrationToEdit) {
      this.form = { ...this.integrationToEdit };
      this.form.events = this.integrationToEdit.events.map(e => e.event);
      this.form.product_id = this.integrationToEdit.events[0].product_id;
    }
  }
};
</script>
<style scoped lang="scss">
.tool-modal-webhook {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .checkbox-group-container {
    display: flex;
    gap: 16px;

    @media screen and (max-width: 991px) {
      flex-direction: column;
    }
  }
}
</style>
